import { render, staticRenderFns } from "./AllContacts.vue?vue&type=template&id=545cbf23&scoped=true&"
import script from "./AllContacts.vue?vue&type=script&lang=js&"
export * from "./AllContacts.vue?vue&type=script&lang=js&"
import style0 from "./AllContacts.vue?vue&type=style&index=0&id=545cbf23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545cbf23",
  null
  
)

export default component.exports